"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFReportMaker = exports.ReportTypeEnum = void 0;
const tslib_1 = require("tslib");
const pdfmake_1 = tslib_1.__importDefault(require("pdfmake/build/pdfmake"));
const vfs_fonts_1 = tslib_1.__importDefault(require("pdfmake/build/vfs_fonts"));
const Report_1 = require("./reportTypes/Report");
const ReportCompositePhoto_1 = require("./reportTypes/ReportCompositePhoto");
const ReportCompositePhotoOnly_1 = require("./reportTypes/ReportCompositePhotoOnly");
const ReportPhoto_1 = require("./reportTypes/ReportPhoto");
const ReportShort_1 = require("./reportTypes/ReportShort");
pdfmake_1.default.vfs = vfs_fonts_1.default.vfs;
var ReportTypeEnum;
(function (ReportTypeEnum) {
    ReportTypeEnum["ReportType"] = "Report";
    ReportTypeEnum["ReportShortType"] = "ReportShort";
    ReportTypeEnum["ReportCompositePhotoType"] = "ReportCompositePhoto";
    ReportTypeEnum["ReportCompositePhotoOnlyType"] = "ReportCompositePhotoOnly";
    ReportTypeEnum["ReportPhotoType"] = "ReportPhoto";
})(ReportTypeEnum || (exports.ReportTypeEnum = ReportTypeEnum = {}));
class PDFReportMaker {
    static makeReport(type, poles) {
        let reportInstance;
        switch (type) {
            case ReportTypeEnum.ReportType:
                reportInstance = new Report_1.Report(poles);
                break;
            case ReportTypeEnum.ReportShortType:
                reportInstance = new ReportShort_1.ReportShort(poles);
                break;
            case ReportTypeEnum.ReportCompositePhotoType:
                reportInstance = new ReportCompositePhoto_1.ReportCompositePhoto(poles);
                break;
            case ReportTypeEnum.ReportCompositePhotoOnlyType:
                reportInstance = new ReportCompositePhotoOnly_1.ReportCompositePhotoOnly(poles);
                break;
            case ReportTypeEnum.ReportPhotoType:
                reportInstance = new ReportPhoto_1.ReportPhoto(poles);
                break;
            default:
                reportInstance = new Report_1.Report(poles);
        }
        return pdfmake_1.default.createPdf(reportInstance.export());
    }
}
exports.PDFReportMaker = PDFReportMaker;
//# sourceMappingURL=ReportMaker.js.map